"use client";

import Script from "next/script";
import { useCookiePreferences } from "@/hooks/useCookiePreferences";

const UET_TAG_ID = "97233277";
const IS_PRODUCTION = process.env.NODE_ENV === "production";

export default function MicrosoftUetLoader() {
  const preferences = useCookiePreferences();
  const marketingAllowed = Boolean(preferences?.marketing);

  if (!IS_PRODUCTION || !marketingAllowed) {
    return null;
  }

  return (
    <>
      {/* UET global site tag */}
      <Script id="microsoft-uet" strategy="afterInteractive">
        {`(function(w,d,t,u,o)
{
  w[u]=w[u]||[],
  o.ts=(new Date).getTime();
  var n=d.createElement(t);
  n.src="https://bat.bing.net/bat.js?ti="+o.ti+("uetq"!=u?"&q="+u:""),
  n.async=1,
  n.onload=n.onreadystatechange=function()
  {
    var s=this.readyState;
    s&&"loaded"!==s&&"complete"!== s||(o.q=w[u], w[u]=new UET(o), w[u].push("pageLoad"), n.onload=n.onreadystatechange=null)
  };
  var i=d.getElementsByTagName(t)[0];
  i.parentNode.insertBefore(n,i);
})(window, document, "script", "uetq", {
  ti:"${UET_TAG_ID}",
  enableAutoSpaTracking:true
});`}
      </Script>
      {/* Update UET consent to granted once marketing cookies are accepted */}
      <Script id="microsoft-uet-consent-update" strategy="afterInteractive">
        {`window.uetq=window.uetq||[];
window.uetq.push('consent','update',{'ad_storage':'granted'});`}
      </Script>
    </>
  );
}
